import { MathJsInstance, create, all } from 'mathjs';

const localMathJS = create({ ...all }, { predictable: true });
const mathJSDefaultValidAlpha = (c: string) => localMathJS.Unit.isValidAlpha(c);
export const patchMathJSValidAlpha = (
  mathJSInstance: MathJsInstance,
  acceptedCharSet: Set<string>,
) => {
  for (const char of acceptedCharSet) {
    if (char.length === 1) continue;
    throw new Error(`Invalid character: ${char}. Must be a single character.`);
  }
  mathJSInstance.Unit.isValidAlpha = (c: string) => {
    return mathJSDefaultValidAlpha(c) || acceptedCharSet.has(c);
  };
};
